import 'core-js/stable'

// First init raygun helper, So it will catch all exceptions!
// import DataDogLogger from '@eig-builder/core-utils/analytics/loggers/datadog-logger'
import { init } from '@eig-builder/core-utils/helpers/apm/datadog-helper'
import { render } from 'react-dom'
import React from 'react'
import Root from 'app'

import { LicenseManager } from 'ag-grid-enterprise'

import './sass/main.scss'

// LicenseManager.setLicenseKey('AppMachine_Control_Panel__1Devs12_July_2019__MTU2Mjg4NjAwMDAwMA==1854ceb2c2140bc13ecb426fafdbb60b')
LicenseManager.setLicenseKey('Evaluation_License_Not_For_Production_20_January_2020__MTU3OTQ3ODQwMDAwMA==b9865d097b4191814e01dc8cbfc4aa7a')

if (!window.EventSource) {
  import(/* webpackChunkName: "event-source-polyfill" */ 'event-source-polyfill') // eslint-disable-line no-unused-expressions
}

if (!window.Intl) {
  import(/* webpackChunkName: "intl" */ 'intl') // eslint-disable-line no-unused-expressions
  import(/* webpackChunkName: "intl-en" */ 'intl/locale-data/jsonp/en.js') // eslint-disable-line no-unused-expressions
}

init('50db94b7-b5eb-4c30-b1c2-cb6f9ba21d30', 'pub5e32217f04b750c7f0ceb9c0a4169ecd', '0.0.1')
// const dataDogLogger = new DataDogLogger()

// dataDogLogger.init(applicationID, clientToken, 'cst-frontend')
// dataDogLogger.initBrowserLogs()

render(<Root />, document.getElementById('root'))

if (module.hot) {
  module.hot.accept('app', () => {
    const NewRoot = require('app').default

    render(<NewRoot />, document.getElementById('root'))
  })
}
